<template>
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.1875 0L8.24906 0.94155L13.2234 6.08324H0V7.43507H13.2234L8.24906 12.5538L9.1875 13.5183L15.75 6.75916L9.1875 0Z"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default {
  name: "RightArrowIcon",
};
</script>
